// extracted by mini-css-extract-plugin
module.exports = {"efUpload":"upload_efUpload__UeVgD"};